import { CarouselList } from './carousel';
import { CarouselProvider } from './carousel.provider';
import { CarouselProviderProps } from './types';

export const Carousel = ({ children, initialSlide = '', controlledSlide, onChange }: CarouselProviderProps) => {
  return (
    <CarouselProvider initialSlide={initialSlide} onChange={onChange} controlledSlide={controlledSlide}>
      {children}
    </CarouselProvider>
  );
};

Carousel.List = CarouselList;
